import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import { Sticker } from '@fagmobler/ui';

export type InspirationCardSize = 'sm' | 'md' | 'lg' | 'full';

export type InspirationCardProps = {
  image: React.ReactNode;
  title?: string;
  createdAt?: string;
  tags?: string[];
  size?: InspirationCardSize;
};

export const InspirationCard = ({
  image,
  title = '',
  size = 'lg',
  createdAt,
  tags = [],
}: InspirationCardProps) => {
  return (
    <article
      className={twMerge(
        clsx('flex flex-col gap-4', {
          'bg-green-30 w-screen relative px-4 py-6 lg:px-16 lg:py-12 left-1/2 -translate-x-1/2 4xl:left-0 4xl:w-full 4xl:translate-x-0 items-center':
            size === 'full',
        })
      )}
    >
      <div
        className={twMerge(
          clsx('overflow-hidden', {
            'h-[157px] md:h-[268px] w-full': size === 'sm',
            'w-full h-[477px]': size === 'md' || size === 'lg',
            'w-full max-w-[976px] aspect-video': size === 'full',
          })
        )}
      >
        <figure className="size-full object-cover-child-img transform transition-transform duration-500 hover:scale-110">
          {image}
        </figure>
      </div>
      <div className="flex flex-col gap-2 w-full max-w-[976px] ">
        <h2 className="hd-md">{title}</h2>
        {createdAt && (
          <span className="body-xs text-neutral-70">
            {new Date(createdAt).toLocaleDateString('nb-NO', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </span>
        )}
      </div>
      <div className="flex flex-row flex-wrap gap-1 w-full max-w-[976px] ">
        {tags.map((tag, index) => (
          <Sticker
            key={index}
            variant="secondaryLighter"
            size="xs"
            className={clsx('rounded-full m-0 !font-normal', {
              'bg-green-50': size === 'full',
              '!hidden lg:inline-block': index >= 2 && size !== 'full',
            })}
          >
            {tag}
          </Sticker>
        ))}
      </div>
    </article>
  );
};

export default InspirationCard;
